<div class="mc-tag__wrapper">
    <span class="mc-tag__text"><ng-content></ng-content></span>
    <ng-content select="[mc-icon]"></ng-content>
    <div class="mc-tag-overlay"></div>
</div>
